import * as MyListActionTypes from './MyListActionTypes';
import * as SavedListActionTypes from './SavedListActionTypes';

export default [...Object.values(MyListActionTypes), ...Object.values(SavedListActionTypes)];
